export const Endpoints = {
  baseUri: "https://lausdappstg.lausd.net", //udpates
  authenticationServices : "https://servicesstg.lausd.net/authentication",
  notificationServices : "https://servicesstg.lausd.net/notifications",
  customerServices : "https://servicesstg.lausd.net/customers",
  communicationsServices : "https://servicesstg.lausd.net/communications",
  calendarServices : "https://servicesstg.lausd.net/calendar",
  facilitiesServices : "https://servicesstg.lausd.net/facilities",
}
export const environment = {
  production: false,
  chat: 'https://lausd.service-now.com/$sn-va-web-client-app.do?sysparm_nostack=true&sysparm_stack=no&sysparm_portal=lausd&sysparm_page=customer_home&sysparm_language=en&sysparm_liveagent_application=csm&sysparm_live_agent_only=false&sysparm_branding_key=lausd_customer_service',
  portal: 'https://lausd.service-now.com/lausd',
  environment_name: "Stage",
  gaTrackingID: "UA-221977737-1",
  enableIAP: false,
  enableChatbot: true,
  enableChatbotVoice: true,  
  chatbotScriptURL: "https://cdn.lausd.net/chatbot/stage/chatbot.js",
  chatbotAPIBaseURL: "https://aiplatformapi.stage.aws.lausd.net",
  endPoints: Endpoints,
  oauth: {
    resourceServer: {
      allowedUrls: [
        Endpoints.authenticationServices,
        Endpoints.customerServices,
        Endpoints.calendarServices,
        Endpoints.notificationServices,
        Endpoints.facilitiesServices,
        Endpoints.communicationsServices
      ],
      sendAccessToken: true,
    }
  },
};
